import { Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Base64Svg from '../assets/base64.svg';
import HtmlSvg from '../assets/html.svg';
import JsonSvg from '../assets/json.svg';
import JwtSvg from '../assets/jwt.svg';
import MarkdownSvg from '../assets/markdown.svg';
import UrlSvg from '../assets/url.svg';
import XmlSvg from '../assets/xml.svg';
import YamlSvg from '../assets/yaml.svg';
import "./Home.css";

export default function Home() {
    const navigate = useNavigate();
    const cards = [
        {
            title: 'JSON',
            navigate: '/json',
            svg: JsonSvg,
            alt: 'json',
        },
        {
            title: 'XML',
            navigate: '/xml',
            svg: XmlSvg,
            alt: 'xml',
        },
        {
            title: 'YAML',
            navigate: '/yaml',
            svg: YamlSvg,
            alt: 'yaml',
        },
        {
            title: 'URL',
            navigate: '/url',
            svg: UrlSvg,
            alt: 'url',
        },
        {
            title: 'HTML',
            navigate: '/html',
            svg: HtmlSvg,
            alt: 'html',
        },
        {
            title: 'Base64',
            navigate: '/base64',
            svg: Base64Svg,
            alt: 'base64',
        },
        {
            title: 'JWT',
            navigate: '/jwt',
            svg: JwtSvg,
            alt: 'jwt',
        },
        {
            title: 'Markdown',
            navigate: '/markdown',
            svg: MarkdownSvg,
            alt: 'markdown',
        },
    ];

    return (
        <div className='card-container'>
            {cards.map((card, i) => 
                <Card onClick={() => navigate(card.navigate)}>
                    <Card.Body>
                        <img src={card.svg} className='svg' alt={card.alt}/>
                        <Card.Title>{card.title}</Card.Title>
                    </Card.Body>
                </Card>
            )}
        </div>
    );
}